
export const Zones = ['S', 'P', 'B', 'H', 'M', 'A', 'U', 'C']
   


// WEBPACK FOOTER //
// ./src/core/services/zones.js